module.exports = function() {
  return new Worker(__webpack_public_path__ + "7d5b041141bafaf57d73.worker.js");
};